export const queryDefaults = {
  gcTimeMs: 5 * 60_000,
  staleTimeMs: 15_000,
} as const;
